import { render, staticRenderFns } from "./Aulic.vue?vue&type=template&id=514ad23a&scoped=true&"
import script from "./Aulic.vue?vue&type=script&lang=js&"
export * from "./Aulic.vue?vue&type=script&lang=js&"
import style0 from "./Aulic.vue?vue&type=style&index=0&id=514ad23a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514ad23a",
  null
  
)

export default component.exports